export default __webpack_public_path__ + "static/media/ojo-estrella-01.aeb7e536.png";